import type { Invoice } from 'src/types';

export const getInvoiceIds = (invoices: Invoice[]) =>
  invoices.map((invoice) => invoice.invoiceId);
